<h3>Edit Property Calendars</h3>

<mat-dialog-content>
  <form [formGroup]="form">
    <div formArrayName="calendars">
      @for (ctrl of calendarControls; track $index; let i = $index) {
        <div class="calendar-row" [formGroup]="ctrl">
            <div>
                <!-- Name -->
                <mat-form-field appearance="outline" class="name-field form-field third-width">
                  <mat-label>Name</mat-label>
                  <input matInput formControlName="name" placeholder="e.g. Summer 2025" />
                  @if (ctrl.controls.name.hasError('required')) {
                    <mat-error>Required</mat-error>
                  }
                </mat-form-field>
                
                <!-- Start Date -->
                <mat-form-field appearance="outline" class="date-field form-field third-width">
                  <mat-label>Start Date</mat-label>
                  <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
                  <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                  @if (ctrl.controls.startDate.hasError('required')) {
                    <mat-error>Required</mat-error>
                  }
                </mat-form-field>
      
                <!-- End Date -->
                <mat-form-field appearance="outline" class="date-field form-field third-width">
                  <mat-label>End Date</mat-label>
                  <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
                  <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                  @if (ctrl.controls.endDate.hasError('required')) {
                    <mat-error>Required</mat-error>
                  }
                </mat-form-field>
      
                <!-- Costs -->
                <mat-form-field appearance="outline" class="cost-field">
                  <mat-label>Cost Per Night</mat-label>
                  <mat-icon matPrefix>attach_money</mat-icon>
                  <input matInput type="number" formControlName="costPerNight" />
                  @if (ctrl.controls.costPerNight.hasError('required')) {
                    <mat-error>Required</mat-error>
                  }
                </mat-form-field>
      
                <mat-form-field appearance="outline" class="cost-field">
                  <mat-label>Cost Per Week</mat-label>
                  <mat-icon matPrefix>attach_money</mat-icon>
                  <input matInput type="number" formControlName="costPerWeek" />
                </mat-form-field>
      
                <mat-form-field appearance="outline" class="cost-field">
                  <mat-label>Cost Per Month</mat-label>
                  <mat-icon matPrefix>attach_money</mat-icon>
                  <input matInput type="number" formControlName="costPerMonth" />
                </mat-form-field>
            </div>

          <!-- Delete -->
          <button
            mat-icon-button
            color="warn"
            type="button"
            (click)="removeCalendar(i)"
            matTooltip="Remove">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }

      <button mat-stroked-button color="primary" type="button" (click)="addCalendar()">
        <mat-icon>add</mat-icon> Add Calendar
      </button>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="warning" (click)="onCancel()">
    <mat-icon matPrefix>cancel</mat-icon> Cancel
  </button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">
    <mat-icon matPrefix>save</mat-icon> Save
  </button>
</mat-dialog-actions>